import { compose } from "@reduxjs/toolkit";
import HomePage from "sections/HomePage";
import attach from "store";

export default compose(attach)(HomePage);
